// jshint strict:false, undef:false, unused:false

/*/
	Navigation Lock
	Stephen Ginn at Crema Design Studio
	
	Stops links and forms from reaching pages a portal has disabled, and opens a modal instead.
	The modal lists the disabled pages in its data-pages attribute. Portals without it are untouched.
/*/

class NavigationLock {
	constructor(selector) {
		this.modal = document.querySelector(selector);
		if (!this.modal) return;
		
		this.pages = this.modal.dataset.pages.split(" ");
		
		// Capture phase runs before any form or link handlers, including inline onsubmit ones
		document.addEventListener("click", e => this.onClick(e), true);
		document.addEventListener("submit", e => this.onSubmit(e), true);
		
		this.showAfterRedirect();
	}
	
	// True when a URL points at one of this site's disabled pages
	isDisabled(url) {
		const target = new URL(url, location.href);
		const page = target.pathname.replace(/^\/+|\/+$/g, "");
		
		return target.origin === location.origin && this.pages.includes(page);
	}
	
	// Links, plus submit buttons so the modal opens before the browser validates the form
	onClick(e) {
		const link = e.target.closest("a[href]");
		const button = e.target.closest("button, input[type=submit], input[type=image]");
		let url = null;
		let trigger = null;
		
		if (link) {
			url = link.href;
			trigger = link;
		} else if (button && button.form && button.type === "submit") {
			url = button.getAttribute("formaction") || button.form.getAttribute("action") || location.href;
			trigger = button;
		}
		
		if (url && this.isDisabled(url)) this.block(e, trigger);
	}
	
	// Catches submissions that skip a button click, such as requestSubmit()
	onSubmit(e) {
		const form = e.target;
		const url = (e.submitter && e.submitter.getAttribute("formaction")) || form.getAttribute("action") || location.href;
		
		if (this.isDisabled(url)) this.block(e, e.submitter || form);
	}
	
	block(e, trigger) {
		e.preventDefault();
		e.stopPropagation();
		this.show(trigger);
	}
	
	// Passes a trigger because the shared show.bs.modal handler in init.js reads relatedTarget.
	// Bootstrap 4 doesn't stack modals, so any open one closes first.
	show(trigger) {
		const $modal = $(this.modal);
		const $open = $(".modal.show").not(this.modal);
		
		if ($open.length) {
			$open.one("hidden.bs.modal", () => $modal.modal("show", trigger));
			$open.modal("hide");
		} else {
			$modal.modal("show", trigger);
		}
	}
	
	// The server sends direct visits to a disabled page home with ?navigation=disabled
	showAfterRedirect() {
		const url = new URL(location.href);
		if (url.searchParams.get("navigation") !== "disabled") return;
		
		url.searchParams.delete("navigation");
		history.replaceState(null, "", url.pathname + url.search + url.hash);
		this.show(this.modal);
	}
}
